import { mapFacetToActive } from '@search/utils';
import { SearchActions } from '../actions';
import { SearchActiveFacetsAction } from '../actions/active-facets.actions';
import { SearchState } from '../search-state';

export const initialState: SearchState['activeFacets'] = [];

export function reducer(
  state: SearchState['activeFacets'] = initialState,
  action: SearchActiveFacetsAction,
): SearchState['activeFacets'] {
  switch (action.type) {
    case SearchActions.TOGGLE_FACET: {
      const {
        payload: { facet, value, force },
      } = action;
      const newState = [...state];
      const index = state.findIndex(
        (activeFacet) => activeFacet.code === facet.code && activeFacet.value.code === value.code,
      );

      if (index !== -1) {
        if (force !== true) {
          return [...state.slice(0, index), ...state.slice(index + 1)];
        }
      } else {
        if (force !== false) {
          newState.push(mapFacetToActive(facet, value));
        }
      }

      return newState;
    }

    case SearchActions.SET_FACET_VALUE: {
      const {
        payload: { facet, value },
      } = action;

      const newState = [...state];

      const index = state.findIndex(({ code }) => code === facet.code);
      const activeFacet = mapFacetToActive(facet, { name: value.toString(), code: value.toString() });

      if (index !== -1) {
        newState[index] = activeFacet;
      } else {
        newState.push(activeFacet);
      }

      return newState;
    }

    case SearchActions.SET_FACET_RANGE_VALUE: {
      const {
        payload: { facet, value },
      } = action;

      const newState = state.filter(({ code }) => code !== facet.code);

      value
        .filter((v) => v != null)
        .map((v) => v.toString())
        .forEach((v) => newState.push(mapFacetToActive(facet, { name: v, code: v })));

      return newState;
    }

    case SearchActions.CLEAR_FACET_VALUE: {
      const {
        payload: { facet },
      } = action;

      return state.filter(({ code }) => code !== facet.code);
    }

    case SearchActions.CLEAR_ALL_FACETS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
